(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["arcane-atmosphere"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__arcaneAtmosphereInit) return;
    window.__arcaneAtmosphereInit = true;

    var REDUCED     = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var FINE_POINTER = matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (REDUCED) return;

    /* ── First-load sweep — removed ── */

    /* ── Scroll-driven + mouse-move parallax + rotation ── */
    function bindScrollEffects() {
      var parallaxEls = document.querySelectorAll('[data-atmosphere-parallax]');
      var rotateEls   = document.querySelectorAll('[data-atmosphere-rotate]');
      if (!parallaxEls.length && !rotateEls.length) return;

      var mouseNX = 0, mouseNY = 0, smoothNX = 0, smoothNY = 0;
      var mouseTicking = false;

      if (FINE_POINTER) {
        document.addEventListener('mousemove', function (e) {
          mouseNX = (e.clientX / window.innerWidth  - 0.5) * 2;
          mouseNY = (e.clientY / window.innerHeight - 0.5) * 2;
          if (!mouseTicking) {
            requestAnimationFrame(function () {
              smoothNX += (mouseNX - smoothNX) * 0.06;
              smoothNY += (mouseNY - smoothNY) * 0.06;
              applyParallax();
              mouseTicking = false;
            });
            mouseTicking = true;
          }
        }, { passive: true });
      }

      var scrollTicking = false;
      function applyParallax() {
        var sy = window.scrollY || 0;
        parallaxEls.forEach(function (el) {
          var factor = parseFloat(el.dataset.atmosphereParallax) || 0.2;
          var rect = el.getBoundingClientRect();
          var dist = rect.top + rect.height / 2 - window.innerHeight / 2;
          var scrollY = dist * factor * -0.18;
          var mx = FINE_POINTER ? smoothNX * factor * 10 : 0;
          var my = FINE_POINTER ? smoothNY * factor * 5  : 0;
          el.style.transform = 'translate3d(' + mx + 'px,' + (scrollY + my) + 'px,0)';
        });
        rotateEls.forEach(function (el) {
          var pxPerRev = parseFloat(el.dataset.atmosphereRotate) || 3000;
          el.style.transform = 'rotate(' + ((sy / pxPerRev) * 360) + 'deg)';
        });
        scrollTicking = false;
      }
      function onScroll() { if (!scrollTicking) { requestAnimationFrame(applyParallax); scrollTicking = true; } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      applyParallax();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindScrollEffects, { once: true });
    } else {
      bindScrollEffects();
    }

    /* ── Horizontal scroll progress bar ── */
    (function() {
      var bar = document.getElementById('arcaneScrollBar');
      if (!bar) return;
      var ticking = false;
      function updateBar() {
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var docH = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        var p = docH > 0 ? scrollTop / docH : 0;
        bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)) + ')';
        ticking = false;
      }
      window.addEventListener('scroll', function() {
        if (!ticking) { requestAnimationFrame(updateBar); ticking = true; }
      }, { passive: true });
      updateBar();
    })();

  })();

  /* ── Loading curtain (runs regardless of reduced-motion guard above) ── */
  (function() {
    var curtain = document.getElementById('arcaneCurtain');
    if (!curtain) return;

    var KEY = 'arcaneEntered';
    var seen = false;
    try { seen = sessionStorage.getItem(KEY) === '1'; } catch(e) {}

    if (seen || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      curtain.classList.add('is-gone');
      return;
    }

    document.body.style.overflow = 'hidden';

    var wordmark = curtain.querySelector('.arcane-curtain__wordmark');
    var bar = document.getElementById('arcaneCurtainBar');
    var vol = curtain.querySelector('.arcane-curtain__vol');

    setTimeout(function() {
      if (wordmark) wordmark.classList.add('is-shown');
      if (vol) vol.classList.add('is-shown');
    }, 90);

    setTimeout(function() {
      if (bar) bar.classList.add('is-filling');
    }, 360);

    setTimeout(function() {
      curtain.classList.add('is-exiting');
      document.body.style.overflow = '';
      try { sessionStorage.setItem(KEY, '1'); } catch(e) {}
    }, 1650);

    setTimeout(function() {
      curtain.classList.add('is-gone');
    }, 2700);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["arcane-progress"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__arcaneVtrakInit) return;
  window.__arcaneVtrakInit = true;

  if (typeof IntersectionObserver === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(max-width: 860px)').matches) return;

  var items = document.querySelectorAll('.arcane-vtrak__item[data-vtrak]');
  if (!items.length) return;

  var activeItem = null;

  function setActive(item) {
    if (item === activeItem) return;
    if (activeItem) activeItem.classList.remove('is-active');
    activeItem = item;
    if (activeItem) activeItem.classList.add('is-active');
  }

  // Detect which section crosses the viewport midpoint.
  // rootMargin '-45% 0px -45%' creates a 10% detection band at center.
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var cls = entry.target.classList;
      var match = null;
      items.forEach(function (item) {
        if (cls.contains(item.dataset.vtrak)) match = item;
      });
      if (match) setActive(match);
    });
  }, {
    rootMargin: '-40% 0px -40% 0px',
    threshold: 0
  });

  items.forEach(function (item) {
    var cls = item.dataset.vtrak;
    var section = document.querySelector('.' + cls);
    if (section) io.observe(section);
  });

  // Mark first visible on load
  var firstSection = document.querySelector('.' + items[0].dataset.vtrak);
  if (firstSection) setActive(items[0]);
})();
  } catch(e) { console.error(e); }
})();

})();
